import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject, Subject } from 'rxjs/Rx';
import { AccountNotification } from '../../customerservice/interface/accountNotification';
import { MemberEmailInfo } from '../../customerservice/interface/member-email-info.interface';
import { DepartmentInfoTab } from '../../customerservice/models/department-info-tab-model';
import { AddressVisibility } from '../interface/address-visibility';

@Injectable()
export class MessageService {

    private userPermissions: Subject<any> = new Subject<any>();
    private productInfo: Subject<any> = new Subject<any>();
    private languageCultures: Subject<any> = new Subject<any>();
    private customerServiceTabs: Subject<any> = new Subject<any>();
    private customerServiceUserTabs: Subject<DepartmentInfoTab> = new Subject<DepartmentInfoTab>();
    private openTabsInfo: Subject<any> = new Subject<any>();
    private recentlyViewedInfo: Subject<any> = new Subject<any>();
    private closeTabsInfo: Subject<any> = new Subject<any>();
    private eventsTab: Subject<any> = new Subject<any>();
    private deleteProductModal: Subject<any> = new Subject<any>();
    private userTabCustomerService: Subject<any> = new Subject<any>();
    private disputeTickets: Subject<any> = new Subject<any>();
    private orderHistoryTabs: Subject<any> = new Subject<any>();
    private closingTabInfo: Subject<any> = new Subject<any>();
    private departmentTabInfo: Subject<any> = new Subject<any>();
    private manageUserTab: Subject<any> = new Subject<any>();
    private addressSaved: Subject<boolean> = new Subject<boolean>();
    private accountNotification: Subject<AccountNotification> = new Subject<AccountNotification>();
    private EmailSearchTabs: Subject<any> = new Subject<any>();
    private memberEmailViewTab: Subject<MemberEmailInfo> = new Subject<MemberEmailInfo>();
    private draftEmailsaved: Subject<boolean> = new Subject<boolean>();
    private auditLogUpdated: Subject<boolean> = new Subject<boolean>();
    private customSelectSubject: Subject<string> = new Subject<string>();
    private enableAddressFields: Subject<AddressVisibility> = new Subject<AddressVisibility>();
    private notifyLogoutSubject: Subject<boolean> = new Subject<boolean>();
    private selectedCountry: Subject<string> = new Subject<string>();
    private submitAddress: Subject<any> = new Subject<any>();
    private bankTypeChange: Subject<any> = new Subject<any>();
    private submitPudoPickupPersonAddress: Subject<any> = new Subject<any>();
    private bonusInfo = new BehaviorSubject<string>("");
    private bsnBonusInfo = new BehaviorSubject<string>("");
    accountNumber = this.bonusInfo.asObservable();
    bsnNumber = this.bsnBonusInfo.asObservable();
    private persistedMemberId: Subject<string> = new Subject<string>();
    private submitPudoDropShipPersonAddress: Subject<any> = new Subject<any>();
    private pudoPersonAddress :Subject<boolean> = new Subject<any>();
    private pudoSuggestedAddress: Subject<any> = new Subject<any>();
    private Flp360AccessDetails :Subject<any>=new Subject<any>();
    private updateExistingPreference: Subject<boolean> = new Subject<boolean>();
    private StoreID :Subject<any>=new Subject<any>();
    private stateCode: Subject<any> = new Subject<any>();
    setAccountNotification(notification: AccountNotification) {
        this.accountNotification.next(notification);
    }

    getAccountNotification(): Observable<AccountNotification> {
        return this.accountNotification.asObservable();
    }

    setDeleteProductModalConf(product: any) {
        this.productInfo.next(product);
    }

    getDeleteProductModalConf(): Observable<any> {
        return this.productInfo.asObservable();
    }

    setAddressSaved(isSaved: boolean) {
        this.addressSaved.next(isSaved);
    }

    getAddressSaved(): Observable<boolean> {
        return this.addressSaved.asObservable();
    }


    setUserPermissionFlag(userPermission: any) {
        this.userPermissions.next(userPermission);
    }

    getUserPermissionFlag(): Observable<any> {
        return this.userPermissions.asObservable();
    }

    /**
     * sets cusotmer service tabs
     * @param customerServiceTabs 
     */
    setCustomerServiceTabContent(customerServiceTabs: any) {
        this.customerServiceTabs.next(customerServiceTabs);
    }

    /**
     * gets customer service tab details
     */
    getCustomerServiceTabContent(): Observable<any> {
        return this.customerServiceTabs.asObservable();
    }

    /**
    * sets cusotmer service tabs
    * @param customerServiceTabs 
    */
    setCustomerServiceUserTabContent(customerServiceTabs: any) {
        this.customerServiceUserTabs.next(customerServiceTabs);
    }

    /**
     * gets customer service tab details
     */
    getCustomerServiceUserTabContent(): Observable<any> {
        return this.customerServiceUserTabs.asObservable();
    }


    /**
        * sets cusotmer service tabs
        *  @param customerServiceManageUserTabs
        */
    setCustomerServiceManageUserTabContent(customerServiceManageUserTabs: any) {
        this.customerServiceUserTabs.next(customerServiceManageUserTabs);
    }
    /**
     * gets customer service tab details
     */
    getCustomerServiceManageUserTabContentt(): Observable<any> {
        return this.customerServiceUserTabs.asObservable();
    }

    setChangedLanguage(languageCulturesLst: any[]) {
        this.languageCultures.next(languageCulturesLst);
    }

    getChangedLanguage(): Observable<any> {
        return this.languageCultures.asObservable();
    }

    /**
     * sets tab info
     * @param tabInfo 
     */
    setOpenTabsInfo(tabInfo: any) {
        this.openTabsInfo.next(tabInfo);
    }

    /**
     * gets tab info
     */
    getOpenTabsInfo(): Observable<any> {
        return this.openTabsInfo.asObservable();
    }

    /**
       * sets recentlyViewedInfo info
       * @param recentlyViewedInfo 
       */
    setRecentlyViewedInfo() {
        this.recentlyViewedInfo.next();
    }

    /**
     * gets recentlyviewed info
     */
    getRecentlyViewedInfo(): Observable<boolean> {
        return this.recentlyViewedInfo.asObservable();
    }


    /**
     * sets close tab event
     * @param tabInfo 
     */
    setCloseTabsEvent(tabInfo: any) {
        this.closeTabsInfo.next(tabInfo);

    }

    /**
     * gets close tab info
     */
    getCloseTabsEvent(): Observable<any> {
        return this.closeTabsInfo.asObservable();
    }
    /**
    * sets events tab flag
    * @param eventTab  
    */
    setEventsTab(eventsTab: any) {
        this.eventsTab.next(eventsTab);
    }

    /**
     * gets events tab flag
     */
    getEventsTab(): Observable<any> {
        return this.eventsTab.asObservable();
    }
    /**
    * sets Customer service tabs
    * @param eventTab  
    */
    setTabs(userTabCustomerService: any) {
        this.userTabCustomerService.next(userTabCustomerService);
    }

    /**
     * gets Customer service tabs
     */
    getTabs(): Observable<any> {
        return this.userTabCustomerService.asObservable();
    }
    /**
     * get updated dispute tickets
     */
    getDisputeTickets(): Observable<any> {
        return this.disputeTickets.asObservable();
    }
    /**
    * sets dispute tickets flag
    * @param disputeTickets  
    */
    setDisputeTickets(disputeTickets: any) {
        this.disputeTickets.next(disputeTickets);
    }
    /**
    * sets cusotmer service Order History tabs
    * @param customerServiceOrderHistoryTabs 
    */
    setOrderHistoryTab(customerServiceTabs: any) {
        this.orderHistoryTabs.next(customerServiceTabs);
    }

    /**
     * gets customer service Order History tab details
     */
    getOrderHistoryTab(): Observable<any> {
        return this.orderHistoryTabs.asObservable();
    }
    /**
         * sets tab index info to be closed
         * @param tabindexinfotobeclosed
         */
    setClosingTabInfo(closingTabInfo: any) {
        this.closingTabInfo.next(closingTabInfo);
    }

    /**
     * gets tab index info to be closed
     */
    getClosingTabInfo(): Observable<any> {
        return this.closingTabInfo.asObservable();
    }

    /**
    * sets department View tabs
    * @param departmentTabInfo 
    */
    setDepartmentTabContent(departmentTab: any) {
        this.departmentTabInfo.next(departmentTab);
    }

    /**
     * gets department View tabs
     */
    getDepartmentTabContent(): Observable<any> {
        return this.departmentTabInfo.asObservable();
    }


    /**
     * sets department View tabs
     * @param manageUserTab 
     */
    setManageUserTab(UserInfoTab: any) {
        this.manageUserTab.next(UserInfoTab);
    }

    /**
     * gets department View tabs
     * @param manageUserTab 
     */

    getManageUserTab(): Observable<any> {
        return this.manageUserTab.asObservable();
    }


    /**
   * sets cusotmer service MemberEmailViewTab
   * @param memberEmailViewTab
   */
    setMemberEmailViewTab(memberEmailInfo: MemberEmailInfo) {
        this.memberEmailViewTab.next(memberEmailInfo);
    }

    /**
     * gets customer service MemberEmailViewTab details
     */
    getMemberEmailViewTab(): Observable<MemberEmailInfo> {
        return this.memberEmailViewTab.asObservable();
    }

    /**
     *  set draft email for ticket details
     * @param isDraftEmailSent 
     */
    setDraftEmailsaved(isDraftEmailSent: boolean) {
        this.draftEmailsaved.next(isDraftEmailSent);
    }
    /**
     * get draft email for ticket details
     */
    getDraftEmailsaved(): Observable<boolean> {
        return this.draftEmailsaved.asObservable();
    }

    setAuditLogUpdated(isAuditLogUpdated: boolean) {
        this.auditLogUpdated.next(isAuditLogUpdated);
    }
    getisAuditLogUpdated(): Observable<boolean> {
        return this.auditLogUpdated.asObservable();
    }

    /**
     * set HeaderData to reset
    */
    setCustomSelect(selectedValue: string) {
        this.customSelectSubject.next(selectedValue);
    }

    /**
     *  get HeaderData Reset
     */
    getCustomSelect(): Observable<string> {
        return this.customSelectSubject.asObservable();
    }

    /**
     * @description
     * @date 2020-03-25
     * @returns {Observable<boolean>}
     * @memberof MessageService
     */
    getEnableAddressFields(): Observable<AddressVisibility> {
        return this.enableAddressFields.asObservable();
    }

    /**
     * @description
     * @date 2020-03-25
     * @param {boolean} enableAddressFields
     * @memberof MessageService
     */
    setEnableAddressFields(enableAddressFields: AddressVisibility) {
        this.enableAddressFields.next(enableAddressFields);
    }

    
    /**
     * @description to update logout status. 
     * @author Akhil
     * @date 2020-05-04
     * @returns {Observable<any>}
     * @memberof MessageService
     */
    getNotifyLogoutStatus(): Observable<any> {
        return this.notifyLogoutSubject.asObservable();
    }

    setNotifyLogoutStatus(isLogin: boolean): void {
        this.notifyLogoutSubject.next(isLogin);
    }

    /**
     * @description to update the selected country 
     * @date 2020-10-09
     * @returns {Observable<any>}
     * @memberof MessageService
     */
    getSelectedCountry(): Observable<any> {
        return this.selectedCountry.asObservable();
    }

    setSelectedCountry(selectedCountry: string): void {
        this.selectedCountry.next(selectedCountry);
    }
    getSubmitAddress(): Observable<any> {
        return this.submitAddress.asObservable();
    }

    setSubmitAddress(isSubmit: boolean): void {
        this.submitAddress.next(isSubmit);
    }

    setBankTypeChange(value:any){
        this.bankTypeChange.next(value);
    }

    getBankTypeChange(): Observable<any>{
        return this.bankTypeChange.asObservable();
    }

    setSubmitPudoPickupPersonAddress(isSubmit: boolean) {
        this.submitPudoPickupPersonAddress.next(isSubmit);
    }
    getSubmitPudoPickupPersonAddress(): Observable<any> {
      return  this.submitPudoPickupPersonAddress.asObservable();
    }

    setBlxBonusInformation(bonusInfo: string) {
        this.bonusInfo.next(bonusInfo);
    }

    setPersitedMemberId(memberId: string) {
        this.persistedMemberId.next(memberId);
    }

    getPersitedMemberId(): Observable<string> {
        return this.persistedMemberId.asObservable();
    }

    setSubmitPudoDropShipPersonAddress(isSubmit: boolean) {
        this.submitPudoDropShipPersonAddress.next(isSubmit);
    }
    getSubmitDropShipPersonAddress(): Observable<any> {
      return  this.submitPudoDropShipPersonAddress.asObservable();
    }
    setPudoPersonAddress(isSubmit: boolean) {
        this.pudoPersonAddress.next(isSubmit);
    }
    getPudoPersonAddress(): Observable<boolean> {
      return  this.pudoPersonAddress.asObservable();
    }
    setBSNNumber(bsnNumber) {
         this.bsnBonusInfo.next(bsnNumber);
    }
    setPUDOSuggestedAddress(pickupPersonAddress: any) {
        this.pudoSuggestedAddress.next(pickupPersonAddress);
    }
    getPUDOSuggestedAddress(): Observable<any> {
        return this.pudoSuggestedAddress.asObservable();
    }


    getFlp360AccessDetails(): Observable<any> {
        return this.Flp360AccessDetails.asObservable();
    }
  
    setFlp360AccessDetails(Flp360AccessDetails: any) {
        this.Flp360AccessDetails.next(Flp360AccessDetails);
    }

    setExistingPrivacyPreference(updateExistingPreference: boolean) {
        this.updateExistingPreference.next(updateExistingPreference);
    }

    getExistingPrivacyPreference(): Observable<boolean> {
        return this.updateExistingPreference.asObservable();
    }

    setStoreID(StoreID: any) {
        this.StoreID.next(StoreID);
    }
       
    getStoreID(): Observable<any> {
        return this.StoreID.asObservable();
    }

    setCities(stateCode : any):void{
        this.stateCode.next(stateCode);
       }
   
       getCities():Observable<any>{
           return this.stateCode.asObservable();
       }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/message.service.ts